module.exports = __webpack_public_path__ + "img/s.c05a0898.jpg";